import { createContext } from 'react'

import { NextRouter } from 'next/router'

import { PATHS } from 'api/paths'
import { callApi } from 'api/utils'
import { getSubotApiPath } from 'api/utils/paths'
import {
  SubotMessage,
  SubotNodeAction,
  SubotNodeItem,
  SubotNodeMessage,
} from 'interfaces/types'
import { Context } from 'state/types'

export type SubotInlineProps = {
  id?: string | number
  isMobile?: boolean
  asPath?: string
  articleLink: string
}

export type SubotInlineContextProps = {
  activeId?: string
  params: SubotMessage
  nodes: Array<SubotNodeItem>
  isMobile?: boolean
  getParams?: (props: {
    bot_id?: string | number
    nextRouter?: NextRouter
  }) => SubotMessage
  onChange?: (message?: SubotMessage) => void
  onSubmit?: (nextNode?: SubotNodeMessage, message?: SubotMessage) => void
  onPrev?: () => void
  onNext?: (message?: SubotMessage) => void
  onReset?: () => void
  trackingCommonInline: Record<string, string | number | undefined | null>
  userInfo?: Context['state']['userInfo']
}

export type ActionsClickProps = {
  node_id: string | number
  actions: Array<SubotNodeAction>
}

export const SubotInlineContext = createContext<SubotInlineContextProps>({
  activeId: '',
  params: {},
  nodes: [],
  trackingCommonInline: {},
})

/** inline click */
export const subotInlineClick = async (data: SubotMessage) => {
  try {
    return await callApi(
      getSubotApiPath(PATHS.SUBOT.GET_INLINE_CLICK),
      'POST',
      {
        data,
      },
    )
  } catch (error) {}
}

/** inline impression */
export const subotInlineImpression = async (data: SubotMessage) => {
  try {
    return await callApi(
      getSubotApiPath(PATHS.SUBOT.GET_INLINE_IMPRESSION),
      'POST',
      {
        data,
      },
    )
  } catch (error) {}
}

/** inline message */
export const subotInlineMessage = async (data: SubotMessage) => {
  try {
    return await callApi(
      getSubotApiPath(PATHS.SUBOT.GET_INLINE_MESSAGE),
      'POST',
      {
        data,
      },
    )
  } catch (error) {}
}

export const computeExtraSettingsForBot = (data: any) => {
  if (data?._status === 1 && data?._data?.extra_settings) {
    try {
      const extraSettingsObj = JSON.parse(data._data.extra_settings)

      if (typeof extraSettingsObj === 'object') {
        data._data.extra_settings = extraSettingsObj
      } else {
        data._data.extra_settings = {
          sync_data_friso_campaign: false,
        }
      }
    } catch (err) {
      data._data.extra_settings = {
        sync_data_friso_campaign: false,
      }
    }
  }
  return data
}

/** inline first node */
export const subotInlineFirstNode = async (id?: string | number) => {
  try {
    const data = await callApi(
      getSubotApiPath(PATHS.SUBOT.GET_INLINE_FIRST_NODE) + `/${id}`,
      'GET',
    )
    computeExtraSettingsForBot(data)
    return data
  } catch (error) {}
}
